import * as React from 'react';

const SupportUserIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 10C0 4.47715 4.47715 0 10 0V0C15.5228 0 20 4.47715 20 10V10C20 15.5228 15.5228 20 10 20V20C4.47715 20 0 15.5228 0 10V10Z"
      fill="url(#paint0_linear_960_32952)"
      fillOpacity="0.5"
    />
    <path
      d="M10 11.625C11.7949 11.625 13.25 10.1699 13.25 8.375C13.25 6.58007 11.7949 5.125 10 5.125C8.20507 5.125 6.75 6.58007 6.75 8.375C6.75 10.1699 8.20507 11.625 10 11.625Z"
      stroke="white"
      strokeMiterlimit="10"
    />
    <path
      d="M5.07373 14.4683C5.57319 13.6038 6.29137 12.8859 7.15611 12.3868C8.02085 11.8877 9.0017 11.625 10.0001 11.625C10.9986 11.625 11.9794 11.8878 12.8441 12.3869C13.7089 12.886 14.427 13.6038 14.9265 14.4684"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_960_32952"
        x1="10"
        y1="-2.94753"
        x2="10"
        y2="23.0093"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1A355D" />
        <stop offset="1" stopColor="#6ACAD8" />
      </linearGradient>
    </defs>
  </svg>
);

export default SupportUserIcon;
